import { createComponent } from '@mtfe/sweet';
import { eventBus } from '@mtfe/sweet-utils';
import { SearchIndex } from '@mtfe/sweet-components';
import tpl from './dom.html';
import style from './style.less';
import http from '../../service';

import store, { createNode } from '../../store';

const { storeCommon } = store;

const Search = async () => {
    const { dom_wm_recommend: domWmRecommend, dom_wm_search: domWmSearch } =
        storeCommon.structInfo.struct;

    eventBus.clearEvent('click-search');
    eventBus.$onceOn('click-search', (searchKeyword) => {
        createNode(domWmSearch.recallBizId);
        createNode(domWmRecommend.recallBizId);
        store[domWmSearch.recallBizId].searchKeyword = searchKeyword;
    });
    const data = {
        searchIndex: await SearchIndex({
            http,
        }),
    };
    const events = {};
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default Search;
